import React from 'react'
import './Project.css'
import { BsPatchCheckFill } from "react-icons/bs";
import { Typography, useTheme } from '@mui/material';
import { tokens } from "../../theme";
import {  Grid } from '@mui/material';


import Experience from './Experience';






export const Projects = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <section id="experience">
      <Typography variant='h3' color={colors.blueAccent[400]} style={{ textAlign: "center" }}>Skills I Used In development</Typography>
      {/* <Typography variant='h2' color={colors.greenAccent[400]} style={{textAlign:"center"}}>My Experiences</Typography> */}
      <div className="container experience__container">
        <Grid className="experience__frontend" flexDirection={{ xs: 'column', sm: 'row', md: 'row', lg: 'row' }} justifyContent={{ xs: 'center', md: 'flex-end' }}
          alignItems={{ xs: 'center', md: 'flex-end' }}>
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>HTML</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>CSS</h4>
                <small className="text-light">Advandced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Javascript</h4>
                <small className="text-light">LoveIt</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Tailwind</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Bootstrap</h4>
                <small className="text-light">Begginer</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>React</h4>
                <small className="text-light">Senior</small>
              </div>
            </article>
          </div>
        </Grid>
        <Grid className="experience__backend" flexDirection={{ xs: 'column', sm: 'row', md: 'row', lg: 'row' }} justifyContent={{ xs: 'center', md: 'flex-end' }}
          alignItems={{ xs: 'center', md: 'flex-end' }}>
          <h3>Backend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>NodeJs</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Express</h4>
                <small className="text-light">Advandced</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Mongo DB</h4>
                <small className="text-light">LoveIt</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>ASP.net</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>MySql</h4>
                <small className="text-light">Begginer</small>
              </div>
            </article>

          </div>
        </Grid>
        
      </div >
      <Grid xs={12} md={12} width={"100%"}  marginTop={10} flexDirection={{ xs: 'column', sm: 'row', md: 'row', lg: 'row' }} justifyContent={{ xs: 'center', md: 'flex-end' }}
          alignItems={{ xs: 'center', md: 'flex-end' }}>
            <Typography variant='h3' color={colors.blueAccent[400]} style={{ textAlign: "center" }} marginBottom={10}>Experience & Education</Typography>
              <Experience></Experience>
        </Grid>
    </section >
  )
}
